import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from "./theme/page-not-found/page-not-found.component";
import { HomeComponent } from './home/home.component';
import { ReportViewerComponent } from "./reports/report-viewer/report-viewer.component";
import { HelpComponent } from './help/help.component';
import { BaaComponent } from './baa/baa.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyComponent } from './privacy/privacy.component';

const routes: Routes = [ 
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'reports', component: ReportViewerComponent},
  { path: 'home', component: HomeComponent },
  { path: 'help', component: HelpComponent },
  { path: 'baa', component: BaaComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'logout', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    CommonModule
    ,RouterModule.forRoot(routes, {enableTracing: false})
  ],
  exports: [ RouterModule ],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts